import NextLink from 'next/link';

import Link from 'shopper/components/Link';

const SiteMapLinkItem = ({ children, ...rest }) => (
  <NextLink prefetch={false} passHref {...rest}>
    <Link className="mb-1 w-fit" size="size1" type="secondary">
      {children}
    </Link>
  </NextLink>
);

export default SiteMapLinkItem;
